module.exports = __webpack_public_path__ + "img/j2.4b016172.png";